
interface HeroSectionProps {
  title: string;
  description: string;
  backgroundImage: string;
}

export function HeroSection({ title, description, backgroundImage }: HeroSectionProps) {
  return (
    <section 
      className="relative py-4 overflow-hidden mt-16"
      style={{
        backgroundImage: `url('${backgroundImage}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="container relative z-10">
        <div className="mb-4 text-center">
          <h1 className="text-5xl font-bold mb-4 text-[#00123A]">{title}</h1>
          <p className="text-lg text-[#00123A]/90 max-w-2xl mx-auto">
            {description}
          </p>
        </div>
      </div>
    </section>
  );
}
